<ng-content></ng-content>

<div *ngIf="isErrorModal">
  <app-chat-error-modal [isErrorModal]="isErrorModal"
    infoSrc="assets/samvaad-assets/images/icons/delete-information-icon.svg"
    [paragraph]="errorMsgForInvalidFile || errorMsgForFileLimit || errorMsgForSizeLimit || errorMsgForSpecialCharacter"
    (onHide)="isErrorModal = false" [samvaadLanguageText]="samvaadLanguageText">
  </app-chat-error-modal>
</div>
